import { Card, CardBody, Col } from "reactstrap";
import { H6, LI, P, UL } from "../../../../AbstractElements";
import { BasicTimelineTitle } from "../../../../Constants/Constants";
import { BasicTimeLineData, BasicTimelineSubTitle } from "../../../../Data/BonusUi/Timeline";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const BasicTimeline = () => {
  return (
    <Col xl="6" className="box-col-6 notification main-timeline">
      <Card className="height-equal">
        <CommonCardHeader title={BasicTimelineTitle} span={BasicTimelineSubTitle} />
        <CardBody className="dark-timeline">
          <UL className="simple-list">
            {BasicTimeLineData &&
              BasicTimeLineData.map((item, index) => (
                <LI className="d-flex" key={index}>
                  <div className={`timeline-dot-${item.class}`} />
                  <div className="w-100 ms-3">
                    <P className="d-flex justify-content-between mb-2">
                      <span className="date-content light-background">{item.date}</span>
                      <span>{item.time}</span>
                    </P>
                    <H6>
                      {item.title}
                      <span className="dot-notification" />
                    </H6>
                    <P className="f-light">{item.text}</P>
                  </div>
                </LI>
              ))}
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};
export default BasicTimeline;
